import type { Release } from '../releases';

export default {
  id: '2026-11-03-meeting-rooms',
  at: '2026-11-04T14:18:00Z',
  title: 'Справочник переговорных в администрировании',
  modules: [],
  items: [
    'В «Администрировании» появилась вкладка «Переговорные»: комнаты офиса и площадок с вместимостью, оборудованием (экран, видеосвязь, доска) и постоянной ссылкой на видеосвязь комнаты.',
    'Комнату на площадке — прорабскую или бытовку — можно привязать к проекту и объекту. Закрытая комната уходит в архив и не пропадает из истории.',
  ],
  why: 'Это первый шаг к назначению встреч в календаре портала: при создании встречи можно будет выбрать комнату и увидеть, свободна ли она.',
  link: '/admin/meeting-rooms',
} satisfies Release;
